export default __webpack_public_path__ + "static/media/spring_boot.619022f8.png";